export default __webpack_public_path__ + "static/media/banner-1.9205e881.png";